module.exports = __webpack_public_path__ + "img/ferienhaus_debontje_greetsiel_bad_oben_1.cb50cd13.jpg";